import type { NewTierPlan } from 'app/hooks/useSubscriptionPlans/getNewTierPlans';

import type { ComparePlansPill } from './types';

// Pill follows catalog isCurrent (cleared in reactivation), not raw currentTier —
// parity with NewTierPlansGrid (6a), which only shows "Plano atual" when plan.isCurrent.
export const getComparePlanPill = (
  key: NewTierPlan['key'],
  isCurrent: boolean,
): ComparePlansPill => {
  if (isCurrent) {
    return 'current';
  }

  if (key === 'ultimate_2026') {
    return 'popular';
  }

  return null;
};
